import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  Decimal: { input: number; output: number; }
  Long: { input: any; output: any; }
  MultiplierPath: { input: any; output: any; }
  NonEmptyString: { input: any; output: any; }
  Upload: { input: File; output: File; }
};

export type ActionNotAllowedError = Error & {
  __typename?: 'ActionNotAllowedError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type AddPatientAuthorizationError = InvalidAddPatientAuthorizationInputError;

export type AddPatientAuthorizationInput = {
  cardAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  clinicalAiAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  facilityCode: Scalars['NonEmptyString']['input'];
  financialPoliciesAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  marketingContentAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  medicalHistoryObtainingAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  privacyPracticesAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  releaseOfInfoToInsurersAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  scribeAuthorzation?: InputMaybe<Scalars['Boolean']['input']>;
  /** PNG format image base64 encoded string */
  signature: Scalars['NonEmptyString']['input'];
  thirdPartyInformationSharingAuthorizationInput?: InputMaybe<ThirdPartyInformationSharingAuthorizationInput>;
  transactionalContentAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
  voiceNotesAiAuthorization?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AddPatientAuthorizationPayload = {
  __typename?: 'AddPatientAuthorizationPayload';
  errors?: Maybe<Array<AddPatientAuthorizationError>>;
  patientAuthorizations?: Maybe<PatientAuthorizations>;
};

export type Address = {
  __typename?: 'Address';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  hasReturnedMail?: Maybe<Scalars['Boolean']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  stateIsoCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AnsweredQuestionnaireQuestionInput = {
  answer: QuestionnaireAnswerInput;
  questionId: Scalars['NonEmptyString']['input'];
};

export enum ApplyPolicy {
  AfterResolver = 'AFTER_RESOLVER',
  BeforeResolver = 'BEFORE_RESOLVER',
  Validation = 'VALIDATION'
}

export type Appointment = {
  __typename?: 'Appointment';
  appointmentsProcedures?: Maybe<Array<AppointmentProcedure>>;
  duration: Scalars['Int']['output'];
  facility?: Maybe<Facility>;
  id: Scalars['String']['output'];
  isCanceled: Scalars['Boolean']['output'];
  isCheckedIn: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  provider?: Maybe<Provider>;
  status: AppointmentStatus;
  timeSlot?: Maybe<Scalars['DateTime']['output']>;
  visitDescription: Scalars['String']['output'];
  visitNumber: Scalars['String']['output'];
};

export type AppointmentProcedure = {
  __typename?: 'AppointmentProcedure';
  fee: Scalars['Float']['output'];
  procedureCode: Scalars['String']['output'];
  procedureDescription: Scalars['String']['output'];
  sequenceNumber: Scalars['Int']['output'];
  surfaceCode: Scalars['String']['output'];
  toothQuadrant: Scalars['String']['output'];
};

export enum AppointmentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Scheduled = 'SCHEDULED'
}

export type Authorizations = {
  __typename?: 'Authorizations';
  authorizationsComplete: Scalars['Boolean']['output'];
  authorizationsId: Scalars['String']['output'];
  state: AuthorizationsEntityState;
};

export enum AuthorizationsEntityState {
  Complete = 'COMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type Benefits = {
  __typename?: 'Benefits';
  benefitsState?: Maybe<BenefitsEntityState>;
  data: BenefitsData;
  flowState?: Maybe<FlowStateOfBenefitsEntityStateAndBenefitsActionType>;
  id: Scalars['String']['output'];
};

export enum BenefitsActionType {
  SetData = 'SET_DATA',
  Start = 'START'
}

export type BenefitsData = {
  __typename?: 'BenefitsData';
  dentalCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
  denturesCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
  setBy?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  totalCoverageRemaining?: Maybe<Scalars['Decimal']['output']>;
};

export enum BenefitsEntityState {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type CanNotStartActionError = Error & {
  __typename?: 'CanNotStartActionError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type CompanyIdentifiersInput = {
  insuranceCompanyId?: InputMaybe<Scalars['String']['input']>;
  insuranceCompanyName?: InputMaybe<Scalars['String']['input']>;
};

export type DriversLicenseScanResponse = {
  __typename?: 'DriversLicenseScanResponse';
  driverLicenseReadout?: Maybe<PersonalInformationSubmittal>;
  fileFrontId?: Maybe<Scalars['String']['output']>;
  fileHeadshotBase64?: Maybe<Scalars['String']['output']>;
  fileHeadshotId?: Maybe<Scalars['String']['output']>;
  fileOtherSideId?: Maybe<Scalars['String']['output']>;
  rotationAngle?: Maybe<Scalars['Int']['output']>;
  rotationAngleOther?: Maybe<Scalars['Int']['output']>;
  switchFirstAndSecond: Scalars['Boolean']['output'];
};

export type Eligibility = {
  __typename?: 'Eligibility';
  data?: Maybe<EligibilityData>;
  eligibilityEntityState?: Maybe<EligibilityEntityState>;
  enhancedEligibilityCheckTimestampUtc?: Maybe<Scalars['DateTime']['output']>;
  enhancedEligibilityState?: Maybe<EnhancedEligibilityState>;
  flowState?: Maybe<FlowStateOfEligibilityEntityStateAndEligibilityActionType>;
  id: Scalars['String']['output'];
};

export enum EligibilityActionType {
  Archive = 'ARCHIVE',
  ManualSet = 'MANUAL_SET',
  NoInsurance = 'NO_INSURANCE',
  SendToIvq = 'SEND_TO_IVQ',
  SetData = 'SET_DATA',
  SetDataAndAutocheck = 'SET_DATA_AND_AUTOCHECK',
  SetNotEligible = 'SET_NOT_ELIGIBLE',
  Start = 'START'
}

export type EligibilityData = {
  __typename?: 'EligibilityData';
  dataGroupOneOfEntryId?: Maybe<Scalars['String']['output']>;
  eligible: Scalars['Boolean']['output'];
  errors?: Maybe<Array<EligibilityDataError>>;
  planProductName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type EligibilityDataError = {
  __typename?: 'EligibilityDataError';
  code?: Maybe<Scalars['String']['output']>;
  followUpCode?: Maybe<EligibilityFollowUpCode>;
  followUpCodeDescription?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<RejectionReason>;
  rejectionReasonDescription?: Maybe<Scalars['String']['output']>;
};

export enum EligibilityEntityState {
  Archived = 'ARCHIVED',
  BackgroundCheckRunning = 'BACKGROUND_CHECK_RUNNING',
  Eligible = 'ELIGIBLE',
  Expired = 'EXPIRED',
  Invalid = 'INVALID',
  NotEligible = 'NOT_ELIGIBLE',
  NoInsurance = 'NO_INSURANCE',
  PendingForEligibilityApiCheck = 'PENDING_FOR_ELIGIBILITY_API_CHECK',
  PendingForManualCheck = 'PENDING_FOR_MANUAL_CHECK',
  ReviewNeeded = 'REVIEW_NEEDED',
  /** @deprecated This state is being deprecated. Use REVIEW_NEEDED instead. */
  UpdateNeeded = 'UPDATE_NEEDED',
  WaitingForData = 'WAITING_FOR_DATA'
}

export enum EligibilityFollowUpCode {
  C = 'C',
  N = 'N',
  P = 'P',
  R = 'R',
  S = 'S',
  W = 'W',
  X = 'X',
  Y = 'Y'
}

export type EmailRejectionReason = {
  __typename?: 'EmailRejectionReason';
  expirationTimestamp: Scalars['DateTime']['output'];
  rejectionReason: EmailRejectionReasonEnum;
};

export enum EmailRejectionReasonEnum {
  DoNotHaveEmail = 'DO_NOT_HAVE_EMAIL',
  RefuseToProvide = 'REFUSE_TO_PROVIDE'
}

export enum EnhancedEligibilityState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type Error = {
  message: Scalars['String']['output'];
};

export type Facility = {
  __typename?: 'Facility';
  code: Scalars['String']['output'];
  location: FacilityLocation;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type FacilityLocation = {
  __typename?: 'FacilityLocation';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  ianaTimeZone: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type FacilityNotFoundError = Error & {
  __typename?: 'FacilityNotFoundError';
  message: Scalars['String']['output'];
};

export type FlowStateOfBenefitsEntityStateAndBenefitsActionType = {
  __typename?: 'FlowStateOfBenefitsEntityStateAndBenefitsActionType';
  state: BenefitsEntityState;
  validActions: Array<BenefitsActionType>;
};

export type FlowStateOfEligibilityEntityStateAndEligibilityActionType = {
  __typename?: 'FlowStateOfEligibilityEntityStateAndEligibilityActionType';
  state: EligibilityEntityState;
  validActions: Array<EligibilityActionType>;
};

export type FlowStateOfInsuranceEntityStateAndInsuranceActionType = {
  __typename?: 'FlowStateOfInsuranceEntityStateAndInsuranceActionType';
  state: InsuranceEntityState;
  validActions: Array<InsuranceActionType>;
};

export type FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType = {
  __typename?: 'FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType';
  state: InsuranceQueueAssignmentEntityState;
  validActions: Array<InsuranceQueueAssignmentActionType>;
};

export type FlowStateOfInsuranceQueueStateAndInsuranceQueueAction = {
  __typename?: 'FlowStateOfInsuranceQueueStateAndInsuranceQueueAction';
  state: InsuranceQueueState;
  validActions: Array<InsuranceQueueAction>;
};

export type FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType = {
  __typename?: 'FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType';
  state: InsuranceSummaryEntityState;
  validActions: Array<InsuranceSummaryActionType>;
};

export type FlowStateOfPatientEntityStateAndPatientActionType = {
  __typename?: 'FlowStateOfPatientEntityStateAndPatientActionType';
  state: PatientEntityState;
  validActions: Array<PatientActionType>;
};

export type FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType = {
  __typename?: 'FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType';
  state: PersonalInformationEntityState;
  validActions: Array<PersonalInformationActionType>;
};

export type FreeTextAnswer = {
  __typename?: 'FreeTextAnswer';
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type FreeTextQuestionnaireAnswerInput = {
  text: Scalars['NonEmptyString']['input'];
};

export type GraphqlMutationError = {
  __typename?: 'GraphqlMutationError';
  message: Scalars['String']['output'];
};

export type IPatientQuestionnaireAnswer = {
  question?: Maybe<QuestionnaireQuestion>;
};

export type Image = {
  __typename?: 'Image';
  data: Scalars['String']['output'];
  dataUrl: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
};

export type Insurance = {
  __typename?: 'Insurance';
  benefits?: Maybe<Benefits>;
  eligibility?: Maybe<Eligibility>;
  flowState?: Maybe<FlowStateOfInsuranceEntityStateAndInsuranceActionType>;
  id?: Maybe<Scalars['String']['output']>;
  insurancePriorityState?: Maybe<InsurancePriority>;
  insuranceQueueState?: Maybe<InsuranceQueueState>;
  insuranceState?: Maybe<InsuranceEntityState>;
  ivfCompletedDate?: Maybe<Scalars['DateTime']['output']>;
  lastEligibilityCheck?: Maybe<Scalars['DateTime']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  queueState?: Maybe<FlowStateOfInsuranceQueueStateAndInsuranceQueueAction>;
  submittal?: Maybe<InsuranceSubmittal>;
  submittals?: Maybe<Array<InsuranceSubmittal>>;
};

export enum InsuranceActionType {
  Unknown = 'UNKNOWN'
}

export type InsuranceAutoTermDetails = {
  __typename?: 'InsuranceAutoTermDetails';
  insuranceCompanyName?: Maybe<Scalars['String']['output']>;
  isLastActiveInsuranceAutoTermed: Scalars['Boolean']['output'];
};

export type InsuranceCardReadout = {
  __typename?: 'InsuranceCardReadout';
  company?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type InsuranceCardScan = {
  __typename?: 'InsuranceCardScan';
  fileBackId?: Maybe<Scalars['String']['output']>;
  fileFrontId: Scalars['String']['output'];
  readout?: Maybe<InsuranceCardReadout>;
  rotationAngleBack?: Maybe<Scalars['Int']['output']>;
  rotationAngleFront?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceCompany = {
  __typename?: 'InsuranceCompany';
  id: Scalars['String']['output'];
  insuranceCompanyMasterId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  supportEligibilityCheck: Scalars['Boolean']['output'];
};

export type InsuranceCompanyIdOrNameMissingError = Error & {
  __typename?: 'InsuranceCompanyIdOrNameMissingError';
  message: Scalars['String']['output'];
};

export enum InsuranceEntityState {
  Archived = 'ARCHIVED',
  Complete = 'COMPLETE',
  Invalid = 'INVALID',
  InIvq = 'IN_IVQ',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type InsuranceNotFoundError = Error & {
  __typename?: 'InsuranceNotFoundError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum InsurancePriority {
  Primary = 'PRIMARY',
  Quaternary = 'QUATERNARY',
  Secondary = 'SECONDARY',
  Tertiary = 'TERTIARY'
}

export enum InsuranceQueueAction {
  SetInformationRequired = 'SET_INFORMATION_REQUIRED',
  SetInformationUpdated = 'SET_INFORMATION_UPDATED',
  SetInProgress = 'SET_IN_PROGRESS'
}

export type InsuranceQueueAssignment = {
  __typename?: 'InsuranceQueueAssignment';
  assignedTo?: Maybe<Scalars['String']['output']>;
  flowState: FlowStateOfInsuranceQueueAssignmentEntityStateAndInsuranceQueueAssignmentActionType;
  insuranceQueueAssignmentEntityState?: Maybe<InsuranceQueueAssignmentEntityState>;
  queueAssignment?: Maybe<QueueAssignment>;
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export enum InsuranceQueueAssignmentActionType {
  Assign = 'ASSIGN',
  SetInformationRequired = 'SET_INFORMATION_REQUIRED',
  SetInformationUpdated = 'SET_INFORMATION_UPDATED',
  SetInProgress = 'SET_IN_PROGRESS'
}

export enum InsuranceQueueAssignmentEntityState {
  AspenDentalAssigned = 'ASPEN_DENTAL_ASSIGNED',
  ExternalAssigned = 'EXTERNAL_ASSIGNED',
  InformationRequired = 'INFORMATION_REQUIRED',
  InformationUpdated = 'INFORMATION_UPDATED',
  InProgress = 'IN_PROGRESS'
}

export enum InsuranceQueueState {
  InformationRequired = 'INFORMATION_REQUIRED',
  InformationUpdated = 'INFORMATION_UPDATED',
  InProgress = 'IN_PROGRESS'
}

export type InsuranceSubmission = {
  __typename?: 'InsuranceSubmission';
  eligibilitySubscriptionTopic: Scalars['String']['output'];
};

export type InsuranceSubmittal = {
  __typename?: 'InsuranceSubmittal';
  accountHolderOtherThanPatient?: Maybe<PrimaryAccountHolder>;
  accountInsuranceId?: Maybe<Scalars['Long']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  eligibilityData?: Maybe<EligibilityData>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceCode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientInfoOverride?: Maybe<PatientInfoOverride>;
  planEffectiveDate?: Maybe<Scalars['Date']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  submittalChannel: SubmittalChannel;
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type InsuranceSummary = {
  __typename?: 'InsuranceSummary';
  flowState: FlowStateOfInsuranceSummaryEntityStateAndInsuranceSummaryActionType;
  hasUrgentFlag: Scalars['Boolean']['output'];
  insuranceAutoTermDetails: InsuranceAutoTermDetails;
  insuranceComplete: Scalars['Boolean']['output'];
  insuranceQueueAssignment?: Maybe<InsuranceQueueAssignment>;
  insurances?: Maybe<Array<Insurance>>;
  isAspenSavingsPlanAsPrimary: Scalars['Boolean']['output'];
};

export enum InsuranceSummaryActionType {
  Unknown = 'UNKNOWN'
}

export enum InsuranceSummaryEntityState {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  NoInsurance = 'NO_INSURANCE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type InsuranceVerificationResponse = {
  __typename?: 'InsuranceVerificationResponse';
  insurance: VerifiedInsurance;
};

export type InvalidAddPatientAuthorizationInputError = Error & {
  __typename?: 'InvalidAddPatientAuthorizationInputError';
  errors: Array<GraphqlMutationError>;
  message: Scalars['String']['output'];
};

export type InvalidBase64ValueError = Error & {
  __typename?: 'InvalidBase64ValueError';
  message: Scalars['String']['output'];
};

export type InvalidDomainTypeError = Error & {
  __typename?: 'InvalidDomainTypeError';
  message: Scalars['String']['output'];
};

export type InvalidFieldError = Error & {
  __typename?: 'InvalidFieldError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type InvalidMedicalHistoryInputError = Error & {
  __typename?: 'InvalidMedicalHistoryInputError';
  errors: Array<GraphqlMutationError>;
  message: Scalars['String']['output'];
};

export type MedicalHistory = {
  __typename?: 'MedicalHistory';
  medicalHistoryComplete: Scalars['Boolean']['output'];
  medicalHistoryId: Scalars['String']['output'];
  state: MedicalHistoryEntityState;
};

export enum MedicalHistoryEntityState {
  Complete = 'COMPLETE',
  WaitingForData = 'WAITING_FOR_DATA'
}

export type MultiChoiceMultiAnswer = {
  __typename?: 'MultiChoiceMultiAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiChoiceSingleAnswer = {
  __typename?: 'MultiChoiceSingleAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type MultiPredefinedQuestionnaireAnswerInput = {
  answerIds: Array<Scalars['NonEmptyString']['input']>;
};

export type MultipleInsurancesFoundError = Error & {
  __typename?: 'MultipleInsurancesFoundError';
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addPatientAuthorization: AddPatientAuthorizationPayload;
  saveInsurance: SaveInsurancePayload;
  skipInsurance: SkipInsurancePayload;
  startCheckIn: StartCheckInPayload;
  submitInsuranceInfo: SubmitInsuranceInfoPayload;
  submitInsuranceInfoV2: SubmitInsuranceInfoV2Payload;
  submitPersonalInformation: SubmitPersonalInformationPayload;
  updateMedicalHistory: UpdateMedicalHistoryPayload;
  uploadAndScanDriversLicense: UploadAndScanDriversLicensePayload;
  uploadAndScanInsuranceCard: UploadAndScanInsuranceCardPayload;
  verifyInsurance: VerifyInsurancePayload;
};


export type MutationAddPatientAuthorizationArgs = {
  input: AddPatientAuthorizationInput;
};


export type MutationSaveInsuranceArgs = {
  input: SaveInsuranceInput;
};


export type MutationSubmitInsuranceInfoArgs = {
  input: SubmitInsuranceInfoInput;
};


export type MutationSubmitInsuranceInfoV2Args = {
  input: SubmitInsuranceInfoV2Input;
};


export type MutationSubmitPersonalInformationArgs = {
  input: SubmitPersonalInformationInput;
};


export type MutationUpdateMedicalHistoryArgs = {
  input: UpdateMedicalHistoryInput;
};


export type MutationUploadAndScanDriversLicenseArgs = {
  input: UploadAndScanDriversLicenseInput;
};


export type MutationUploadAndScanInsuranceCardArgs = {
  input: UploadAndScanInsuranceCardInput;
};


export type MutationVerifyInsuranceArgs = {
  input: VerifyInsuranceInput;
};

export type NewPatientSummary = {
  __typename?: 'NewPatientSummary';
  lastNpWelcomeCallDatetime?: Maybe<Scalars['DateTime']['output']>;
  npWelcomeCall: NpWelcomeCallStatus;
};

export enum NpWelcomeCallStatus {
  Attempted = 'ATTEMPTED',
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED'
}

export type ParentQuestionTrigger = {
  __typename?: 'ParentQuestionTrigger';
  answerId: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
};

export type Patient = {
  __typename?: 'Patient';
  allowOfficesToCompleteInsurance?: Maybe<Scalars['Boolean']['output']>;
  authorizations?: Maybe<Authorizations>;
  flowState: FlowStateOfPatientEntityStateAndPatientActionType;
  id: Scalars['String']['output'];
  identifiers: PatientIdentifiers;
  insurance?: Maybe<Insurance>;
  insuranceSummary: InsuranceSummary;
  insurances?: Maybe<Array<Insurance>>;
  medicalHistory?: Maybe<MedicalHistory>;
  newPatient: NewPatientSummary;
  nextAppointment?: Maybe<Appointment>;
  personalInformation?: Maybe<PersonalInformation>;
};

export enum PatientActionType {
  Appoint = 'APPOINT',
  Checkin = 'CHECKIN',
  Prospect = 'PROSPECT',
  Verify = 'VERIFY'
}

export type PatientAuthorizations = {
  __typename?: 'PatientAuthorizations';
  cardAuthorization?: Maybe<Scalars['Boolean']['output']>;
  clinicalAiAuthorization?: Maybe<Scalars['Boolean']['output']>;
  financialPoliciesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  marketingContentAuthorization?: Maybe<Scalars['Boolean']['output']>;
  medicalHistoryObtainingAuthorization?: Maybe<Scalars['Boolean']['output']>;
  privacyPracticesAuthorization?: Maybe<Scalars['Boolean']['output']>;
  releaseOfInfoToInsurersAuthorization?: Maybe<Scalars['Boolean']['output']>;
  scribeAuthorzation?: Maybe<Scalars['Boolean']['output']>;
  signature?: Maybe<Image>;
  thirdPartyInformationSharingAuthorization?: Maybe<ThirdPartyInformationSharingAuthorization>;
  transactionalContentAuthorization?: Maybe<Scalars['Boolean']['output']>;
  voiceNotesAiAuthorization?: Maybe<Scalars['Boolean']['output']>;
};

export enum PatientEntityState {
  Appointed = 'APPOINTED',
  CheckedIn = 'CHECKED_IN',
  Prospected = 'PROSPECTED',
  Verified = 'VERIFIED'
}

export type PatientFreeTextAnswer = IPatientQuestionnaireAnswer & {
  __typename?: 'PatientFreeTextAnswer';
  question: QuestionnaireQuestion;
  text: Scalars['String']['output'];
};

export type PatientIdentifiers = {
  __typename?: 'PatientIdentifiers';
  accountNumber: Scalars['String']['output'];
  patientCode: Scalars['String']['output'];
};

export type PatientInfoOverride = {
  __typename?: 'PatientInfoOverride';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type PatientMedicalHistory = {
  __typename?: 'PatientMedicalHistory';
  answers?: Maybe<Array<IPatientQuestionnaireAnswer>>;
};

export type PatientNotFoundError = Error & {
  __typename?: 'PatientNotFoundError';
  id?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export enum PatientPhoneTypeEnum {
  Cell = 'CELL',
  Home = 'HOME',
  Other = 'OTHER',
  Work = 'WORK'
}

export type PatientPredefinedAnswer = IPatientQuestionnaireAnswer & {
  __typename?: 'PatientPredefinedAnswer';
  answerIds: Array<Scalars['String']['output']>;
  question: QuestionnaireQuestion;
};

export type Period = {
  __typename?: 'Period';
  from?: Maybe<Scalars['DateTime']['output']>;
  to?: Maybe<Scalars['DateTime']['output']>;
};

export type PeriodInput = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};

export type PersonalInformation = {
  __typename?: 'PersonalInformation';
  address?: Maybe<Address>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  driversLicenseBackImageUrl?: Maybe<Scalars['String']['output']>;
  driversLicenseFrontImageUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailRejectionReason?: Maybe<EmailRejectionReason>;
  firstName?: Maybe<Scalars['String']['output']>;
  flowState: FlowStateOfPersonalInformationEntityStateAndPersonalInformationActionType;
  headshotImageUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  personalInformationComplete: Scalars['Boolean']['output'];
  phones?: Maybe<Array<Phone>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  submittal?: Maybe<PersonalInformationSubmittal>;
  submittals?: Maybe<Array<PersonalInformationSubmittal>>;
  timestamp: Scalars['DateTime']['output'];
  verificationResult?: Maybe<VerificationResult>;
};

export enum PersonalInformationActionType {
  SetAndConfirm = 'SET_AND_CONFIRM',
  SetDataUnconfirmed = 'SET_DATA_UNCONFIRMED',
  Start = 'START'
}

export enum PersonalInformationEntityState {
  Confirmed = 'CONFIRMED',
  Incomplete = 'INCOMPLETE',
  PendingForConfirmation = 'PENDING_FOR_CONFIRMATION'
}

export type PersonalInformationSubmittal = {
  __typename?: 'PersonalInformationSubmittal';
  address?: Maybe<Address>;
  completenessScore: Scalars['Int']['output'];
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  diffsToCurrentApplied?: Maybe<Array<SubmittalDiffValue>>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phones?: Maybe<Array<Phone>>;
  preferredName?: Maybe<Scalars['String']['output']>;
  setBy: Scalars['String']['output'];
  sex?: Maybe<Sex>;
  submittalChannel: SubmittalChannel;
  timestamp: Scalars['DateTime']['output'];
};

export type Phone = {
  __typename?: 'Phone';
  phoneNumber: Scalars['String']['output'];
  type: PatientPhoneTypeEnum;
  useToConfirm: Scalars['Boolean']['output'];
};

export type PredefinedAnswer = {
  __typename?: 'PredefinedAnswer';
  answerId: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

export type PrimaryAccountHolder = {
  __typename?: 'PrimaryAccountHolder';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  patientIs?: Maybe<RelationToSubscriber>;
};

export type PrimaryAccountHolderSelfCheckinInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  patientIs?: InputMaybe<RelationToSubscriber>;
};

export type Provider = {
  __typename?: 'Provider';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  insuranceCompanies: Array<InsuranceCompany>;
  me?: Maybe<User>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  questionnaireId: Scalars['String']['output'];
  questions?: Maybe<Array<QuestionnaireQuestion>>;
};

export type QuestionnaireAnswer = FreeTextAnswer | MultiChoiceMultiAnswer | MultiChoiceSingleAnswer | YesNoAnswer;

export enum QuestionnaireAnswerFormat {
  CheckBoxList = 'CHECK_BOX_LIST',
  CheckBoxListNone = 'CHECK_BOX_LIST_NONE',
  Date = 'DATE',
  Dropdown = 'DROPDOWN',
  Height = 'HEIGHT',
  MultiSelect = 'MULTI_SELECT',
  Phone = 'PHONE',
  RadioButton = 'RADIO_BUTTON',
  TextArea = 'TEXT_AREA',
  TextBox = 'TEXT_BOX',
  Weight = 'WEIGHT'
}

export type QuestionnaireAnswerInput = {
  freeTextAnswer?: InputMaybe<FreeTextQuestionnaireAnswerInput>;
  multiAnswer?: InputMaybe<MultiPredefinedQuestionnaireAnswerInput>;
  singleAnswer?: InputMaybe<SinglePredefinedQuestionnaireAnswerInput>;
};

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  answer: QuestionnaireAnswer;
  answerRequired: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  questionId: Scalars['String']['output'];
  sectionType?: Maybe<Scalars['String']['output']>;
  triggers?: Maybe<Array<ParentQuestionTrigger>>;
};

export enum QueueAssignment {
  AspenDental = 'ASPEN_DENTAL',
  External = 'EXTERNAL'
}

export enum RejectionReason {
  AuthorizationAccessRestrictions = 'AUTHORIZATION_ACCESS_RESTRICTIONS',
  AuthorizedQuantityExceeded = 'AUTHORIZED_QUANTITY_EXCEEDED',
  ClaimSubmittedPastExercisePeriod = 'CLAIM_SUBMITTED_PAST_EXERCISE_PERIOD',
  DateOfDeathPrecedesDos = 'DATE_OF_DEATH_PRECEDES_DOS',
  DobFollowsDos = 'DOB_FOLLOWS_DOS',
  DosInTheFuture = 'DOS_IN_THE_FUTURE',
  DosNotWithinAllowableInquiryPeriod = 'DOS_NOT_WITHIN_ALLOWABLE_INQUIRY_PERIOD',
  DuplicatePatientIdNumber = 'DUPLICATE_PATIENT_ID_NUMBER',
  DuplicateSequenceNumber = 'DUPLICATE_SEQUENCE_NUMBER',
  DuplicateSubscriberInsuredIdNumber = 'DUPLICATE_SUBSCRIBER_INSURED_ID_NUMBER',
  Inactive = 'INACTIVE',
  InappropriateDate = 'INAPPROPRIATE_DATE',
  InappropriateProductServiceId = 'INAPPROPRIATE_PRODUCT_SERVICE_ID',
  InappropriateProductServiceIdQualifier = 'INAPPROPRIATE_PRODUCT_SERVICE_ID_QUALIFIER',
  InconsistentWithPatientsAge = 'INCONSISTENT_WITH_PATIENTS_AGE',
  InconsistentWithPatientsGender = 'INCONSISTENT_WITH_PATIENTS_GENDER',
  InputErrors = 'INPUT_ERRORS',
  InquiredBenefitInconsistentWithProviderType = 'INQUIRED_BENEFIT_INCONSISTENT_WITH_PROVIDER_TYPE',
  InvalidMissingDateOfBirth = 'INVALID_MISSING_DATE_OF_BIRTH',
  InvalidMissingDateOfService = 'INVALID_MISSING_DATE_OF_SERVICE',
  InvalidMissingDod = 'INVALID_MISSING_DOD',
  InvalidMissingPatientGenderCode = 'INVALID_MISSING_PATIENT_GENDER_CODE',
  InvalidMissingPatientId = 'INVALID_MISSING_PATIENT_ID',
  InvalidMissingPatientName = 'INVALID_MISSING_PATIENT_NAME',
  InvalidMissingProviderIdentification = 'INVALID_MISSING_PROVIDER_IDENTIFICATION',
  InvalidMissingProviderName = 'INVALID_MISSING_PROVIDER_NAME',
  InvalidMissingProviderPhoneNumber = 'INVALID_MISSING_PROVIDER_PHONE_NUMBER',
  InvalidMissingProviderSpecialty = 'INVALID_MISSING_PROVIDER_SPECIALTY',
  InvalidMissingProviderState = 'INVALID_MISSING_PROVIDER_STATE',
  InvalidMissingReferringProviderIdentificationNumber = 'INVALID_MISSING_REFERRING_PROVIDER_IDENTIFICATION_NUMBER',
  InvalidMissingSubscriberInsuredGenderCode = 'INVALID_MISSING_SUBSCRIBER_INSURED_GENDER_CODE',
  InvalidMissingSubscriberInsuredId = 'INVALID_MISSING_SUBSCRIBER_INSURED_ID',
  InvalidMissingSubscriberInsuredName = 'INVALID_MISSING_SUBSCRIBER_INSURED_NAME',
  InvalidParticipantIdentification = 'INVALID_PARTICIPANT_IDENTIFICATION',
  NotApplicableForEligibility = 'NOT_APPLICABLE_FOR_ELIGIBILITY',
  NoCoverage = 'NO_COVERAGE',
  NoData = 'NO_DATA',
  NoResponseReceivedTransactionTerminated = 'NO_RESPONSE_RECEIVED_TRANSACTION_TERMINATED',
  OutOfNetwork = 'OUT_OF_NETWORK',
  PatientDobDoesNotMatchThatForThePatientOnTheDatabase = 'PATIENT_DOB_DOES_NOT_MATCH_THAT_FOR_THE_PATIENT_ON_THE_DATABASE',
  PatientNotFound = 'PATIENT_NOT_FOUND',
  PayerIdNotProvided = 'PAYER_ID_NOT_PROVIDED',
  PayerNameOrIdentifierMissing = 'PAYER_NAME_OR_IDENTIFIER_MISSING',
  ProviderIneligibleForInquiries = 'PROVIDER_INELIGIBLE_FOR_INQUIRIES',
  ProviderIsNotPrimaryCarePhysician = 'PROVIDER_IS_NOT_PRIMARY_CARE_PHYSICIAN',
  ProviderNotOnFile = 'PROVIDER_NOT_ON_FILE',
  RequiredApplicationDataMissing = 'REQUIRED_APPLICATION_DATA_MISSING',
  ServiceDatesNotWithinProviderPlanEnrollment = 'SERVICE_DATES_NOT_WITHIN_PROVIDER_PLAN_ENROLLMENT',
  ServiceUnavailable = 'SERVICE_UNAVAILABLE',
  SubscriberFoundPatientNotFound = 'SUBSCRIBER_FOUND_PATIENT_NOT_FOUND',
  SubscriberInsuredNotFound = 'SUBSCRIBER_INSURED_NOT_FOUND',
  SubscriberInsuredNotInGroupIdPlanIdentified = 'SUBSCRIBER_INSURED_NOT_IN_GROUP_ID_PLAN_IDENTIFIED',
  TestingNotIncluded = 'TESTING_NOT_INCLUDED',
  UnableToRespondAtCurrentTime = 'UNABLE_TO_RESPOND_AT_CURRENT_TIME',
  Unknown = 'UNKNOWN',
  UnknownAaaError = 'UNKNOWN_AAA_ERROR',
  ZuubInactivePatient = 'ZUUB_INACTIVE_PATIENT',
  ZuubInternal = 'ZUUB_INTERNAL',
  ZuubInvalidCredentials = 'ZUUB_INVALID_CREDENTIALS',
  ZuubPatientDataSuppressed = 'ZUUB_PATIENT_DATA_SUPPRESSED',
  ZuubPatientNotEligible = 'ZUUB_PATIENT_NOT_ELIGIBLE',
  ZuubPatientNotFound = 'ZUUB_PATIENT_NOT_FOUND',
  ZuubPlanNotFound = 'ZUUB_PLAN_NOT_FOUND',
  ZuubProviderNotFound = 'ZUUB_PROVIDER_NOT_FOUND',
  ZuubSiteConfiguration = 'ZUUB_SITE_CONFIGURATION',
  ZuubSiteMaintenance = 'ZUUB_SITE_MAINTENANCE',
  ZuubThirdPartyAdministrator = 'ZUUB_THIRD_PARTY_ADMINISTRATOR',
  ZuubTwoFactorAuthentication = 'ZUUB_TWO_FACTOR_AUTHENTICATION',
  ZuubTwoFactorAuthenticationConfiguration = 'ZUUB_TWO_FACTOR_AUTHENTICATION_CONFIGURATION',
  ZuubUpstream = 'ZUUB_UPSTREAM'
}

export enum RelationToSubscriber {
  Child = 'CHILD',
  DisabledDependant = 'DISABLED_DEPENDANT',
  Husband = 'HUSBAND',
  OtherDependant = 'OTHER_DEPENDANT',
  Wife = 'WIFE'
}

export type SaveInsuranceError = ActionNotAllowedError;

export type SaveInsuranceInput = {
  frontImage?: InputMaybe<Scalars['String']['input']>;
  supportEligibilityCheck: Scalars['Boolean']['input'];
  verificationResponse: VerifiedInsuranceInput;
};

export type SaveInsurancePayload = {
  __typename?: 'SaveInsurancePayload';
  errors?: Maybe<Array<SaveInsuranceError>>;
  saveInsuranceResponse?: Maybe<SaveInsuranceResponse>;
};

export type SaveInsuranceResponse = {
  __typename?: 'SaveInsuranceResponse';
  success: Scalars['Boolean']['output'];
};

export type SetPersonalInformationRequestInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressStateCode?: InputMaybe<Scalars['String']['input']>;
  addressZipCode?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  driversLicenseBackScanId?: InputMaybe<Scalars['String']['input']>;
  driversLicenseFrontScanId?: InputMaybe<Scalars['String']['input']>;
  driversLicenseHeadshotId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Sex>;
};

export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER',
  Unspecified = 'UNSPECIFIED'
}

export type SinglePredefinedQuestionnaireAnswerInput = {
  answerId: Scalars['NonEmptyString']['input'];
};

export type SkipInsuranceError = ActionNotAllowedError | MultipleInsurancesFoundError | PatientNotFoundError;

export type SkipInsurancePayload = {
  __typename?: 'SkipInsurancePayload';
  errors?: Maybe<Array<SkipInsuranceError>>;
  insuranceSummary?: Maybe<InsuranceSummary>;
};

export type StartCheckInPayload = {
  __typename?: 'StartCheckInPayload';
  patient?: Maybe<Patient>;
};

export type SubmitInsuranceInfoError = ActionNotAllowedError | FacilityNotFoundError | InsuranceCompanyIdOrNameMissingError | InsuranceNotFoundError | InvalidBase64ValueError | InvalidDomainTypeError | PatientNotFoundError;

export type SubmitInsuranceInfoInput = {
  input: SubmitInsuranceInfoSelfCheckinInput;
};

export type SubmitInsuranceInfoPayload = {
  __typename?: 'SubmitInsuranceInfoPayload';
  errors?: Maybe<Array<SubmitInsuranceInfoError>>;
  insurance?: Maybe<Insurance>;
};

export type SubmitInsuranceInfoSelfCheckinInput = {
  facilityCode?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanBackId?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanFrontId?: InputMaybe<Scalars['String']['input']>;
  insuranceCompany?: InputMaybe<CompanyIdentifiersInput>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  planEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  primaryAccountHolderOtherThanPatient?: InputMaybe<PrimaryAccountHolderSelfCheckinInput>;
  subscriberNumber: Scalars['String']['input'];
};

export type SubmitInsuranceInfoSelfCheckinRequestInput = {
  facilityCode?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanBackId?: InputMaybe<Scalars['String']['input']>;
  insuranceCardScanFrontId?: InputMaybe<Scalars['String']['input']>;
  insuranceCompany?: InputMaybe<CompanyIdentifiersInput>;
  insuranceId?: InputMaybe<Scalars['String']['input']>;
  planEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  primaryAccountHolderOtherThanPatient?: InputMaybe<PrimaryAccountHolderSelfCheckinInput>;
  subscriberNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitInsuranceInfoV2Error = ActionNotAllowedError | CanNotStartActionError | FacilityNotFoundError | InsuranceCompanyIdOrNameMissingError | InsuranceNotFoundError | PatientNotFoundError;

export type SubmitInsuranceInfoV2Input = {
  request: SubmitInsuranceInfoSelfCheckinRequestInput;
};

export type SubmitInsuranceInfoV2Payload = {
  __typename?: 'SubmitInsuranceInfoV2Payload';
  errors?: Maybe<Array<SubmitInsuranceInfoV2Error>>;
  insuranceSubmission?: Maybe<InsuranceSubmission>;
};

export type SubmitPersonalInformationError = ActionNotAllowedError;

export type SubmitPersonalInformationInput = {
  request: SetPersonalInformationRequestInput;
};

export type SubmitPersonalInformationPayload = {
  __typename?: 'SubmitPersonalInformationPayload';
  errors?: Maybe<Array<SubmitPersonalInformationError>>;
  personalInformation?: Maybe<PersonalInformation>;
};

export enum SubmittalChannel {
  InOfficeCheckinIPad = 'IN_OFFICE_CHECKIN_I_PAD',
  InOfficeCheckinManual = 'IN_OFFICE_CHECKIN_MANUAL',
  InOfficeCheckinReview = 'IN_OFFICE_CHECKIN_REVIEW',
  InOfficeCheckinScanner = 'IN_OFFICE_CHECKIN_SCANNER',
  InOfficeIvq = 'IN_OFFICE_IVQ',
  PatientGraphQlCompleteEligibilityReview = 'PATIENT_GRAPH_QL_COMPLETE_ELIGIBILITY_REVIEW',
  PreVisitCall = 'PRE_VISIT_CALL',
  Unknown = 'UNKNOWN',
  WebSchedule = 'WEB_SCHEDULE',
  WebSelfCheckin = 'WEB_SELF_CHECKIN'
}

export enum SubmittalDiffField {
  AddressLine = 'ADDRESS_LINE',
  City = 'CITY',
  DateOfBirth = 'DATE_OF_BIRTH',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  MiddleName = 'MIDDLE_NAME',
  PreferredName = 'PREFERRED_NAME',
  Sex = 'SEX',
  State = 'STATE',
  Zip = 'ZIP'
}

export type SubmittalDiffValue = {
  __typename?: 'SubmittalDiffValue';
  field: SubmittalDiffField;
  previous?: Maybe<Scalars['String']['output']>;
  submitted?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyInformationSharingAuthorization = {
  __typename?: 'ThirdPartyInformationSharingAuthorization';
  fullName?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Period>;
  relation?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyInformationSharingAuthorizationInput = {
  fullName: Scalars['NonEmptyString']['input'];
  period?: InputMaybe<PeriodInput>;
  relation: Scalars['NonEmptyString']['input'];
};

export type UpdateMedicalHistoryError = InvalidMedicalHistoryInputError;

export type UpdateMedicalHistoryInput = {
  answers: Array<AnsweredQuestionnaireQuestionInput>;
  signature: Scalars['NonEmptyString']['input'];
};

export type UpdateMedicalHistoryPayload = {
  __typename?: 'UpdateMedicalHistoryPayload';
  errors?: Maybe<Array<UpdateMedicalHistoryError>>;
  patientMedicalHistory?: Maybe<PatientMedicalHistory>;
};

export type UploadAndScanDriversLicenseInput = {
  fileFirst?: InputMaybe<Scalars['Upload']['input']>;
  fileHeadshot?: InputMaybe<Scalars['Upload']['input']>;
  fileSecond?: InputMaybe<Scalars['Upload']['input']>;
};

export type UploadAndScanDriversLicensePayload = {
  __typename?: 'UploadAndScanDriversLicensePayload';
  driversLicenseScanResponse?: Maybe<DriversLicenseScanResponse>;
};

export type UploadAndScanInsuranceCardInput = {
  fileBack?: InputMaybe<Scalars['Upload']['input']>;
  fileFront: Scalars['Upload']['input'];
};

export type UploadAndScanInsuranceCardPayload = {
  __typename?: 'UploadAndScanInsuranceCardPayload';
  insuranceCardScan?: Maybe<InsuranceCardScan>;
};

export type User = {
  __typename?: 'User';
  currentMedicalHistory?: Maybe<PatientMedicalHistory>;
  medicalHistoryQuestionnaire: Questionnaire;
  myAccount?: Maybe<UserAccount>;
  patient?: Maybe<Patient>;
  patientAuthorizations?: Maybe<PatientAuthorizations>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  roles: Array<Scalars['String']['output']>;
};

export type VerificationResult = {
  __typename?: 'VerificationResult';
  setBy: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

export type VerifiedBenefits = {
  __typename?: 'VerifiedBenefits';
  coverageAmountForDentistry?: Maybe<Scalars['Decimal']['output']>;
  coverageAmountForDentures?: Maybe<Scalars['Decimal']['output']>;
  coverageAmountRemaining?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['String']['output'];
  lastValueSetBy?: Maybe<Scalars['String']['output']>;
  patientId: Scalars['String']['output'];
  state: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type VerifiedBenefitsInput = {
  coverageAmountForDentistry?: InputMaybe<Scalars['Decimal']['input']>;
  coverageAmountForDentures?: InputMaybe<Scalars['Decimal']['input']>;
  coverageAmountRemaining?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['String']['input'];
  lastValueSetBy?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
  state: Scalars['String']['input'];
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerifiedEligibility = {
  __typename?: 'VerifiedEligibility';
  dataGroupOneOfEntryId?: Maybe<Scalars['String']['output']>;
  eligibilityErrors?: Maybe<Array<VerifiedEligibilityError>>;
  enhancedEligibilityCheckTimestampUtc?: Maybe<Scalars['DateTime']['output']>;
  enhancedEligibilityState?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEligible: Scalars['Boolean']['output'];
  patientId: Scalars['String']['output'];
  setBy: Scalars['String']['output'];
  state: Scalars['String']['output'];
  submissionData?: Maybe<VerifiedSubmittedData>;
  timestamp: Scalars['DateTime']['output'];
};

export type VerifiedEligibilityError = {
  __typename?: 'VerifiedEligibilityError';
  code?: Maybe<Scalars['String']['output']>;
  followUpCode?: Maybe<Scalars['String']['output']>;
  followUpCodeDescription?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  rejectionReasonDescription?: Maybe<Scalars['String']['output']>;
};

export type VerifiedEligibilityErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  followUpCode?: InputMaybe<Scalars['String']['input']>;
  followUpCodeDescription?: InputMaybe<Scalars['String']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  rejectionReasonDescription?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedEligibilityInput = {
  dataGroupOneOfEntryId?: InputMaybe<Scalars['String']['input']>;
  eligibilityErrors?: InputMaybe<Array<VerifiedEligibilityErrorInput>>;
  enhancedEligibilityCheckTimestampUtc?: InputMaybe<Scalars['DateTime']['input']>;
  enhancedEligibilityState?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isEligible: Scalars['Boolean']['input'];
  patientId: Scalars['String']['input'];
  setBy: Scalars['String']['input'];
  state: Scalars['String']['input'];
  submissionData?: InputMaybe<VerifiedSubmittedDataInput>;
  timestamp: Scalars['DateTime']['input'];
};

export type VerifiedInsurance = {
  __typename?: 'VerifiedInsurance';
  benefits?: Maybe<VerifiedBenefits>;
  eligibility: VerifiedEligibility;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type VerifiedInsuranceInput = {
  benefits?: InputMaybe<VerifiedBenefitsInput>;
  eligibility: VerifiedEligibilityInput;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
};

export type VerifiedPatientInfoOverride = {
  __typename?: 'VerifiedPatientInfoOverride';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type VerifiedPatientInfoOverrideInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type VerifiedPrimaryAccountHolder = {
  __typename?: 'VerifiedPrimaryAccountHolder';
  dateOfBirth: Scalars['Date']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  patientIs?: Maybe<Scalars['String']['output']>;
};

export type VerifiedPrimaryAccountHolderInput = {
  dateOfBirth: Scalars['Date']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  patientIs?: InputMaybe<Scalars['String']['input']>;
};

export type VerifiedSubmittedData = {
  __typename?: 'VerifiedSubmittedData';
  accountInsuranceId?: Maybe<Scalars['Long']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  facilityId?: Maybe<Scalars['Int']['output']>;
  groupNumber?: Maybe<Scalars['String']['output']>;
  insuranceCardBackId?: Maybe<Scalars['String']['output']>;
  insuranceCardFrontId?: Maybe<Scalars['String']['output']>;
  insuranceCode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  patientInfoOverride?: Maybe<VerifiedPatientInfoOverride>;
  planEffectiveDate?: Maybe<Scalars['Date']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  primaryAccountHolderOtherThanPatient?: Maybe<VerifiedPrimaryAccountHolder>;
  setBy?: Maybe<Scalars['String']['output']>;
  subscriberNumber?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
};

export type VerifiedSubmittedDataInput = {
  accountInsuranceId?: InputMaybe<Scalars['Long']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['Int']['input']>;
  groupNumber?: InputMaybe<Scalars['String']['input']>;
  insuranceCardBackId?: InputMaybe<Scalars['String']['input']>;
  insuranceCardFrontId?: InputMaybe<Scalars['String']['input']>;
  insuranceCode?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  patientInfoOverride?: InputMaybe<VerifiedPatientInfoOverrideInput>;
  planEffectiveDate?: InputMaybe<Scalars['Date']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  primaryAccountHolderOtherThanPatient?: InputMaybe<VerifiedPrimaryAccountHolderInput>;
  setBy?: InputMaybe<Scalars['String']['input']>;
  subscriberNumber?: InputMaybe<Scalars['String']['input']>;
  timestamp: Scalars['DateTime']['input'];
};

export type VerifyInsuranceError = ActionNotAllowedError | CanNotStartActionError | FacilityNotFoundError | InsuranceCompanyIdOrNameMissingError | InsuranceNotFoundError | InvalidBase64ValueError | InvalidDomainTypeError | InvalidFieldError | PatientNotFoundError;

export type VerifyInsuranceInput = {
  input: SubmitInsuranceInfoSelfCheckinInput;
};

export type VerifyInsurancePayload = {
  __typename?: 'VerifyInsurancePayload';
  errors?: Maybe<Array<VerifyInsuranceError>>;
  insuranceVerificationResponse?: Maybe<InsuranceVerificationResponse>;
};

export type YesNoAnswer = {
  __typename?: 'YesNoAnswer';
  answers?: Maybe<Array<PredefinedAnswer>>;
  format?: Maybe<QuestionnaireAnswerFormat>;
};

export type AddPatientAuthorizationMutationVariables = Exact<{
  input: AddPatientAuthorizationInput;
}>;


export type AddPatientAuthorizationMutation = { __typename?: 'Mutation', addPatientAuthorization: { __typename?: 'AddPatientAuthorizationPayload', patientAuthorizations?: { __typename?: 'PatientAuthorizations', signature?: { __typename?: 'Image', dataUrl: string } | null } | null, errors?: Array<{ __typename?: 'InvalidAddPatientAuthorizationInputError', message: string }> | null } };

export type SaveInsuranceMutationVariables = Exact<{
  input: SaveInsuranceInput;
}>;


export type SaveInsuranceMutation = { __typename?: 'Mutation', saveInsurance: { __typename?: 'SaveInsurancePayload', saveInsuranceResponse?: { __typename?: 'SaveInsuranceResponse', success: boolean } | null } };

export type SavePatientDetailsMutationVariables = Exact<{
  submitPersonalInformationInput: SubmitPersonalInformationInput;
}>;


export type SavePatientDetailsMutation = { __typename?: 'Mutation', submitPersonalInformation: { __typename?: 'SubmitPersonalInformationPayload', errors?: Array<{ __typename: 'ActionNotAllowedError', id?: string | null, message: string }> | null } };

export type ScanIdentificationMutationVariables = Exact<{
  uploadAndScanDriversLicenseInput: UploadAndScanDriversLicenseInput;
}>;


export type ScanIdentificationMutation = { __typename?: 'Mutation', uploadAndScanDriversLicense: { __typename?: 'UploadAndScanDriversLicensePayload', driversLicenseScanResponse?: { __typename?: 'DriversLicenseScanResponse', fileFrontId?: string | null, fileHeadshotId?: string | null, fileOtherSideId?: string | null, driverLicenseReadout?: { __typename?: 'PersonalInformationSubmittal', completenessScore: number, dateOfBirth?: string | null, firstName?: string | null, lastName?: string | null, sex?: Sex | null, address?: { __typename?: 'Address', addressLine1?: string | null, city?: string | null, stateCode?: string | null, stateIsoCode?: string | null, zipCode?: string | null } | null } | null } | null } };

export type ScanInsuranceMutationVariables = Exact<{
  uploadAndScanInsuranceCardInput: UploadAndScanInsuranceCardInput;
}>;


export type ScanInsuranceMutation = { __typename?: 'Mutation', uploadAndScanInsuranceCard: { __typename?: 'UploadAndScanInsuranceCardPayload', insuranceCardScan?: { __typename?: 'InsuranceCardScan', fileFrontId: string, fileBackId?: string | null, readout?: { __typename?: 'InsuranceCardReadout', company?: string | null, memberId?: string | null, name?: string | null } | null } | null } };

export type VerifyInsuranceMutationVariables = Exact<{
  input: VerifyInsuranceInput;
}>;


export type VerifyInsuranceMutation = { __typename?: 'Mutation', verifyInsurance: { __typename?: 'VerifyInsurancePayload', insuranceVerificationResponse?: { __typename?: 'InsuranceVerificationResponse', insurance: { __typename?: 'VerifiedInsurance', id: string, externalId?: string | null, priority?: number | null, eligibility: { __typename?: 'VerifiedEligibility', id: string, patientId: string, state: string, isEligible: boolean, setBy: string, timestamp: string, dataGroupOneOfEntryId?: string | null, enhancedEligibilityCheckTimestampUtc?: string | null, enhancedEligibilityState?: string | null, eligibilityErrors?: Array<{ __typename?: 'VerifiedEligibilityError', code?: string | null, rejectionReason?: string | null, followUpCode?: string | null, followUpCodeDescription?: string | null, rejectionReasonDescription?: string | null }> | null, submissionData?: { __typename?: 'VerifiedSubmittedData', accountInsuranceId?: any | null, companyId?: string | null, companyName?: string | null, insuranceCode?: string | null, groupNumber?: string | null, subscriberNumber?: string | null, planName?: string | null, planEffectiveDate?: string | null, note?: string | null, insuranceCardFrontId?: string | null, insuranceCardBackId?: string | null, facilityId?: number | null, setBy?: string | null, timestamp: string, primaryAccountHolderOtherThanPatient?: { __typename?: 'VerifiedPrimaryAccountHolder', firstName: string, lastName: string, dateOfBirth: string, patientIs?: string | null } | null, patientInfoOverride?: { __typename?: 'VerifiedPatientInfoOverride', firstName: string, lastName: string, dateOfBirth: string } | null } | null }, benefits?: { __typename?: 'VerifiedBenefits', id: string, patientId: string, state: string, coverageAmountRemaining?: number | null, coverageAmountForDentistry?: number | null, coverageAmountForDentures?: number | null, lastValueSetBy?: string | null, timestamp?: string | null } | null } } | null } };

export type AccountInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountInformationQuery = { __typename?: 'Query', me?: { __typename?: 'User', patient?: { __typename?: 'Patient', personalInformation?: { __typename?: 'PersonalInformation', sex?: Sex | null, email?: string | null, lastName?: string | null, firstName?: string | null, dateOfBirth?: string | null, phones?: Array<{ __typename?: 'Phone', phoneNumber: string }> | null } | null } | null, patientAuthorizations?: { __typename?: 'PatientAuthorizations', cardAuthorization?: boolean | null, financialPoliciesAuthorization?: boolean | null, privacyPracticesAuthorization?: boolean | null, scribeAuthorzation?: boolean | null, marketingContentAuthorization?: boolean | null, transactionalContentAuthorization?: boolean | null, medicalHistoryObtainingAuthorization?: boolean | null, releaseOfInfoToInsurersAuthorization?: boolean | null, clinicalAiAuthorization?: boolean | null, voiceNotesAiAuthorization?: boolean | null, signature?: { __typename?: 'Image', dataUrl: string, data: string } | null } | null } | null };

export type GetPatientStepStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientStepStatusQuery = { __typename?: 'Query', me?: { __typename?: 'User', patient?: { __typename?: 'Patient', personalInformation?: { __typename?: 'PersonalInformation', personalInformationComplete: boolean } | null, medicalHistory?: { __typename?: 'MedicalHistory', medicalHistoryComplete: boolean } | null, authorizations?: { __typename?: 'Authorizations', authorizationsComplete: boolean } | null, insuranceSummary: { __typename?: 'InsuranceSummary', insuranceComplete: boolean } } | null } | null };

export type ListInsuranceCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListInsuranceCompaniesQuery = { __typename?: 'Query', insuranceCompanies: Array<{ __typename?: 'InsuranceCompany', id: string, name: string, supportEligibilityCheck: boolean }> };

export type GetPatientIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPatientIdQuery = { __typename?: 'Query', me?: { __typename?: 'User', patient?: { __typename?: 'Patient', id: string } | null } | null };

export type PatientInsurancesQueryVariables = Exact<{ [key: string]: never; }>;


export type PatientInsurancesQuery = { __typename?: 'Query', me?: { __typename?: 'User', patient?: { __typename?: 'Patient', insurances?: Array<{ __typename?: 'Insurance', id?: string | null, insurancePriorityState?: InsurancePriority | null, priority?: number | null, eligibility?: { __typename?: 'Eligibility', data?: { __typename?: 'EligibilityData', eligible: boolean } | null, flowState?: { __typename?: 'FlowStateOfEligibilityEntityStateAndEligibilityActionType', state: EligibilityEntityState } | null } | null, submittal?: { __typename?: 'InsuranceSubmittal', accountInsuranceId?: any | null, companyId?: string | null, companyName?: string | null, groupNumber?: string | null, insuranceCode?: string | null, note?: string | null, planEffectiveDate?: string | null, planName?: string | null, setBy: string, submittalChannel: SubmittalChannel, subscriberNumber?: string | null, timestamp: string, accountHolderOtherThanPatient?: { __typename?: 'PrimaryAccountHolder', dateOfBirth: string, firstName: string, lastName: string, patientIs?: RelationToSubscriber | null } | null } | null }> | null, personalInformation?: { __typename?: 'PersonalInformation', firstName?: string | null, lastName?: string | null } | null } | null } | null };


export const AddPatientAuthorizationDocument = gql`
    mutation AddPatientAuthorization($input: AddPatientAuthorizationInput!) {
  addPatientAuthorization(input: $input) {
    patientAuthorizations {
      signature {
        dataUrl
      }
    }
    errors {
      ... on InvalidAddPatientAuthorizationInputError {
        message
      }
    }
  }
}
    `;

export function useAddPatientAuthorizationMutation() {
  return Urql.useMutation<AddPatientAuthorizationMutation, AddPatientAuthorizationMutationVariables>(AddPatientAuthorizationDocument);
};
export const SaveInsuranceDocument = gql`
    mutation SaveInsurance($input: SaveInsuranceInput!) {
  saveInsurance(input: $input) {
    saveInsuranceResponse {
      success
    }
  }
}
    `;

export function useSaveInsuranceMutation() {
  return Urql.useMutation<SaveInsuranceMutation, SaveInsuranceMutationVariables>(SaveInsuranceDocument);
};
export const SavePatientDetailsDocument = gql`
    mutation savePatientDetails($submitPersonalInformationInput: SubmitPersonalInformationInput!) {
  submitPersonalInformation(input: $submitPersonalInformationInput) {
    errors {
      __typename
      ... on ActionNotAllowedError {
        id
        message
      }
      ... on Error {
        message
      }
    }
  }
}
    `;

export function useSavePatientDetailsMutation() {
  return Urql.useMutation<SavePatientDetailsMutation, SavePatientDetailsMutationVariables>(SavePatientDetailsDocument);
};
export const ScanIdentificationDocument = gql`
    mutation scanIdentification($uploadAndScanDriversLicenseInput: UploadAndScanDriversLicenseInput!) {
  uploadAndScanDriversLicense(input: $uploadAndScanDriversLicenseInput) {
    driversLicenseScanResponse {
      driverLicenseReadout {
        address {
          addressLine1
          city
          stateCode
          stateIsoCode
          zipCode
        }
        completenessScore
        dateOfBirth
        firstName
        lastName
        sex
      }
      fileFrontId
      fileHeadshotId
      fileOtherSideId
    }
  }
}
    `;

export function useScanIdentificationMutation() {
  return Urql.useMutation<ScanIdentificationMutation, ScanIdentificationMutationVariables>(ScanIdentificationDocument);
};
export const ScanInsuranceDocument = gql`
    mutation scanInsurance($uploadAndScanInsuranceCardInput: UploadAndScanInsuranceCardInput!) {
  uploadAndScanInsuranceCard(input: $uploadAndScanInsuranceCardInput) {
    insuranceCardScan {
      readout {
        company
        memberId
        name
      }
      fileFrontId
      fileBackId
    }
  }
}
    `;

export function useScanInsuranceMutation() {
  return Urql.useMutation<ScanInsuranceMutation, ScanInsuranceMutationVariables>(ScanInsuranceDocument);
};
export const VerifyInsuranceDocument = gql`
    mutation VerifyInsurance($input: VerifyInsuranceInput!) {
  verifyInsurance(input: $input) {
    insuranceVerificationResponse {
      insurance {
        id
        externalId
        priority
        eligibility {
          id
          patientId
          state
          isEligible
          eligibilityErrors {
            code
            rejectionReason
            followUpCode
            followUpCodeDescription
            rejectionReasonDescription
          }
          setBy
          timestamp
          dataGroupOneOfEntryId
          submissionData {
            accountInsuranceId
            companyId
            companyName
            insuranceCode
            groupNumber
            subscriberNumber
            planName
            planEffectiveDate
            note
            insuranceCardFrontId
            insuranceCardBackId
            primaryAccountHolderOtherThanPatient {
              firstName
              lastName
              dateOfBirth
              patientIs
            }
            patientInfoOverride {
              firstName
              lastName
              dateOfBirth
            }
            facilityId
            setBy
            timestamp
          }
          enhancedEligibilityCheckTimestampUtc
          enhancedEligibilityState
        }
        benefits {
          id
          patientId
          state
          coverageAmountRemaining
          coverageAmountForDentistry
          coverageAmountForDentures
          lastValueSetBy
          timestamp
        }
      }
    }
  }
}
    `;

export function useVerifyInsuranceMutation() {
  return Urql.useMutation<VerifyInsuranceMutation, VerifyInsuranceMutationVariables>(VerifyInsuranceDocument);
};
export const AccountInformationDocument = gql`
    query accountInformation {
  me {
    patient {
      personalInformation {
        sex
        email
        lastName
        firstName
        dateOfBirth
        phones {
          phoneNumber
        }
      }
    }
    patientAuthorizations {
      signature {
        dataUrl
        data
      }
      cardAuthorization
      financialPoliciesAuthorization
      privacyPracticesAuthorization
      scribeAuthorzation
      marketingContentAuthorization
      transactionalContentAuthorization
      medicalHistoryObtainingAuthorization
      releaseOfInfoToInsurersAuthorization
      clinicalAiAuthorization
      voiceNotesAiAuthorization
    }
  }
}
    `;

export function useAccountInformationQuery(options?: Omit<Urql.UseQueryArgs<AccountInformationQueryVariables>, 'query'>) {
  return Urql.useQuery<AccountInformationQuery, AccountInformationQueryVariables>({ query: AccountInformationDocument, ...options });
};
export const GetPatientStepStatusDocument = gql`
    query getPatientStepStatus {
  me {
    patient {
      personalInformation {
        personalInformationComplete
      }
      medicalHistory {
        medicalHistoryComplete
      }
      authorizations {
        authorizationsComplete
      }
      insuranceSummary {
        insuranceComplete
      }
    }
  }
}
    `;

export function useGetPatientStepStatusQuery(options?: Omit<Urql.UseQueryArgs<GetPatientStepStatusQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientStepStatusQuery, GetPatientStepStatusQueryVariables>({ query: GetPatientStepStatusDocument, ...options });
};
export const ListInsuranceCompaniesDocument = gql`
    query listInsuranceCompanies {
  insuranceCompanies {
    id
    name
    supportEligibilityCheck
  }
}
    `;

export function useListInsuranceCompaniesQuery(options?: Omit<Urql.UseQueryArgs<ListInsuranceCompaniesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListInsuranceCompaniesQuery, ListInsuranceCompaniesQueryVariables>({ query: ListInsuranceCompaniesDocument, ...options });
};
export const GetPatientIdDocument = gql`
    query getPatientId {
  me {
    patient {
      id
    }
  }
}
    `;

export function useGetPatientIdQuery(options?: Omit<Urql.UseQueryArgs<GetPatientIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetPatientIdQuery, GetPatientIdQueryVariables>({ query: GetPatientIdDocument, ...options });
};
export const PatientInsurancesDocument = gql`
    query patientInsurances {
  me {
    patient {
      insurances {
        id
        insurancePriorityState
        priority
        eligibility {
          data {
            eligible
          }
          flowState {
            state
          }
        }
        submittal {
          accountInsuranceId
          companyId
          companyName
          groupNumber
          insuranceCode
          note
          planEffectiveDate
          planName
          setBy
          submittalChannel
          subscriberNumber
          timestamp
          accountHolderOtherThanPatient {
            dateOfBirth
            firstName
            lastName
            patientIs
          }
        }
      }
      personalInformation {
        firstName
        lastName
      }
    }
  }
}
    `;

export function usePatientInsurancesQuery(options?: Omit<Urql.UseQueryArgs<PatientInsurancesQueryVariables>, 'query'>) {
  return Urql.useQuery<PatientInsurancesQuery, PatientInsurancesQueryVariables>({ query: PatientInsurancesDocument, ...options });
};